"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { RiImageEditLine } from "react-icons/ri";
import { MarketingExportDialog } from "@/components/photo-studio/marketing/marketing-export-dialog";
import { Button } from "@/components/ui";
import { useUser } from "@/contexts/user-provider";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
import { cx } from "@/lib/tailwind-utils";
interface Props {
  patientId: string;
  // Open with these photos already picked (e.g. from the compare screen).
  beforeAttachmentId?: string | null;
  afterAttachmentId?: string | null;
  // Toolbar size, like the gallery's Capture button; the label hides when narrow.
  compact?: boolean;
  className?: string;
}
export function MarketingExportButton(t0) {
  const $ = _c(27);
  const {
    patientId,
    beforeAttachmentId,
    afterAttachmentId,
    compact: t1,
    className
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const {
    currentUser
  } = useUser();
  const [open, setOpen] = useState(false);
  if (!hasPermission(currentUser, PERMISSIONS.CLINICAL_GALLERY_READ)) {
    return null;
  }
  const t2 = compact ? undefined : "sm";
  const t3 = compact ? "secondary" : "primary";
  const t4 = compact ? "Marketing before/after" : undefined;
  const t5 = compact && "shrink-0 gap-1 px-2 py-1 text-caption";
  let t6;
  if ($[0] !== className || $[1] !== t5) {
    t6 = cx(t5, className);
    $[0] = className;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpen(true);
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = !compact && "mr-1";
  let t9;
  if ($[4] !== t8) {
    t9 = cx("size-4", t8);
    $[4] = t8;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== t9) {
    t10 = <RiImageEditLine className={t9} />;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const t11 = compact && "hidden @lg:inline";
  let t12;
  if ($[8] !== t11) {
    t12 = cx(t11);
    $[8] = t11;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== t12) {
    t13 = <span className={t12}>Marketing before/after</span>;
    $[10] = t12;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== t10 || $[13] !== t13 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t6) {
    t14 = <Button size={t2} variant={t3} aria-label="Marketing before/after" tooltip={t4} className={t6} onClick={t7}>{t10}{t13}</Button>;
    $[12] = t10;
    $[13] = t13;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== afterAttachmentId || $[20] !== beforeAttachmentId || $[21] !== open || $[22] !== patientId) {
    t15 = open && <MarketingExportDialog patientId={patientId} open={open} onOpenChange={setOpen} initialBeforeId={beforeAttachmentId} initialAfterId={afterAttachmentId} />;
    $[19] = afterAttachmentId;
    $[20] = beforeAttachmentId;
    $[21] = open;
    $[22] = patientId;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14 || $[25] !== t15) {
    t16 = <>{t14}{t15}</>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}